import { Grid2, Skeleton } from "@mui/material";
import SubscriptionCard from "@shop/components/SubscriptionCard";
import React from "react";
import { useShopSlice } from "@store/slices/shop";
import { State } from "@store/state";

const features = {
    S: ["Maßgeschneiderter Workshop rund um ESG & KI", "Auf Wunsch individuelle Inhalte"],
    L: ["Kostenloses Erstgespräch", "Persönliche Durchführung der doppelten Wesentlichkeitsanalyse", "Persönliche IRO-Identifizierung zu allen wesentlichen Themen"],
    XL: ["Kostenloses Erstgespräch", "Persönliche Beratung zu ESG, KI und Immobilien"],
};

const ConsultingSelection = () => {
    const { products } = useShopSlice();

    const p1 = products.find((product: State.Product) => product.name.includes("Workshop ESG"));
    const p2 = products.find((product: State.Product) => product.name.includes("Workshop KI"));

    // Show loading skeletons only during initial load (when products array is empty)
    if (products.length === 0) {
        return (
            <Grid2 container size={12} spacing={3} justifyContent={"center"}>
                <Grid2 container size={12} justifyContent={"center"}>
                    <Grid2>
                        <Skeleton variant="rectangular" width={260} height={360} sx={{ borderRadius: 2 }} />
                    </Grid2>

                    <Grid2>
                        <Skeleton variant="rectangular" width={260} height={360} sx={{ borderRadius: 2 }} />
                    </Grid2>

                    <Grid2>
                        <Skeleton variant="rectangular" width={260} height={360} sx={{ borderRadius: 2 }} />
                    </Grid2>
                    <Grid2>
                        <Skeleton variant="rectangular" width={260} height={360} sx={{ borderRadius: 2 }} />
                    </Grid2>
                </Grid2>
            </Grid2>
        );
    }

    return (
        <Grid2 container size={12} spacing={3} justifyContent={"center"}>
            <Grid2 container size={12} justifyContent={"center"}>
                <Grid2>
                    <SubscriptionCard title={"Workshop ESG & KI"} monthlyPrice={(p1?.prices?.[0]?.amount || 0) / 100} features={features["S"]} hideButton isStartingAt />
                </Grid2>

                <Grid2>
                    <SubscriptionCard
                        title={"Wesentlichkeitsanalyse"}
                        monthlyPrice={0}
                        features={features["L"]}
                        isOnRequest
                        hideButton
                        onClick={() => window.open("https://esgbot.de/kontakt", "_blank", "noopener,noreferrer")}
                    />
                </Grid2>

                <Grid2>
                    <SubscriptionCard
                        title={"Beratung"}
                        monthlyPrice={0}
                        features={features["XL"]}
                        isOnRequest
                        hideButton
                        onClick={() => window.open("https://esgbot.de/kontakt", "_blank", "noopener,noreferrer")}
                    />
                </Grid2>
            </Grid2>
        </Grid2>
    );
};

export default ConsultingSelection;
